import React from 'react';
import { observer } from 'mobx-react';
import { Dropdown, OptionType, OptionValue } from 'radiance-ui';

import { FormFieldType } from 'jsx/components/formHelper';

import FieldWrapper from '../fieldWrapper';

interface FormSelectProps {
  field: FormFieldType<string>;
  options: { value: string; label: string; disabled?: boolean }[];
  onChange?: (value: OptionValue) => void;
  onFocus?: () => void;
  hideLabel?: boolean;
  [key: string]: unknown;
}

const FormSelect: React.FC<FormSelectProps> = ({
  field,
  options,
  onChange,
  onFocus,
  hideLabel = false,
  ...rest
}) => {
  const { id, value } = field;

  const onSelectChange = (option: OptionType) => {
    if (option.value === undefined) {
      return;
    }

    field.set(option.value);

    if (onChange) {
      onChange(option.value);
    }
  };

  const onSelectFocus = () => {
    if (onFocus) {
      onFocus();
    }
  };

  return (
    <FieldWrapper field={field} hideLabel={hideLabel} hideErrorIcon>
      <Dropdown
        {...field}
        id={id}
        value={value}
        options={options}
        onChange={onSelectChange}
        onDropdownContainerFocus={onSelectFocus}
        {...rest}
      />
    </FieldWrapper>
  );
};

export default observer(FormSelect);
